var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:_vm.computedClass,attrs:{"src":_vm.imgSrc || _vm.defaultUrl,"alt":_vm.imgAlt},on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}})
}
var staticRenderFns = []

export { render, staticRenderFns }